export default __webpack_public_path__ + "static/media/about_us_hero.3cbcbf90.jpg";